import CryptoJS from 'crypto-js'

// 与 Java 完全一致
const FIX_KEY = '3tTYzJGj2OBJrUaT'
const FIX_IV = '8QNp0XjokDiBzLs4'

// 固定密钥加密（无长度限制，输出 HEX）
export function aesEncryptFixed(data) {
  const key = CryptoJS.enc.Utf8.parse(FIX_KEY)
  const iv = CryptoJS.enc.Utf8.parse(FIX_IV)

  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(data),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
}

// 固定密钥解密（无长度限制）
export function aesDecryptFixed(hexStr) {
  const key = CryptoJS.enc.Utf8.parse(FIX_KEY)
  const iv = CryptoJS.enc.Utf8.parse(FIX_IV)

  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(hexStr)
  })

  const decrypted = CryptoJS.AES.decrypt(
    cipherParams,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  return decrypted.toString(CryptoJS.enc.Utf8)
}
